export default __webpack_public_path__ + "static/media/dashboard_data_points.c73c4474.svg";